/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AdminEmissionsRecordsStatsListProviderWithSourceParameterInner,
    AdminEmissionsRecordsStatsListProviderWithSourceParameterInnerFromJSON,
    AdminEmissionsRecordsStatsListProviderWithSourceParameterInnerToJSON,
} from '../models/AdminEmissionsRecordsStatsListProviderWithSourceParameterInner';
import {
    type AerialImagesList,
    AerialImagesListFromJSON,
    AerialImagesListToJSON,
} from '../models/AerialImagesList';
import {
    type DataPointMap,
    DataPointMapFromJSON,
    DataPointMapToJSON,
} from '../models/DataPointMap';
import {
    type DataSurveyData,
    DataSurveyDataFromJSON,
    DataSurveyDataToJSON,
} from '../models/DataSurveyData';
import {
    type EmissionRecordMap,
    EmissionRecordMapFromJSON,
    EmissionRecordMapToJSON,
} from '../models/EmissionRecordMap';
import {
    type EquipmentMapList,
    EquipmentMapListFromJSON,
    EquipmentMapListToJSON,
} from '../models/EquipmentMapList';
import {
    type GeoJSONFeatureCollection,
    GeoJSONFeatureCollectionFromJSON,
    GeoJSONFeatureCollectionToJSON,
} from '../models/GeoJSONFeatureCollection';
import {
    type PaginatedAerialImagesListList,
    PaginatedAerialImagesListListFromJSON,
    PaginatedAerialImagesListListToJSON,
} from '../models/PaginatedAerialImagesListList';
import {
    type PaginatedDataPointMapList,
    PaginatedDataPointMapListFromJSON,
    PaginatedDataPointMapListToJSON,
} from '../models/PaginatedDataPointMapList';
import {
    type PaginatedDataSurveyList,
    PaginatedDataSurveyListFromJSON,
    PaginatedDataSurveyListToJSON,
} from '../models/PaginatedDataSurveyList';
import {
    type PaginatedEmissionRecordMapList,
    PaginatedEmissionRecordMapListFromJSON,
    PaginatedEmissionRecordMapListToJSON,
} from '../models/PaginatedEmissionRecordMapList';
import {
    type PaginatedEquipmentMapListList,
    PaginatedEquipmentMapListListFromJSON,
    PaginatedEquipmentMapListListToJSON,
} from '../models/PaginatedEquipmentMapListList';
import {
    type PaginatedPipelineMapListList,
    PaginatedPipelineMapListListFromJSON,
    PaginatedPipelineMapListListToJSON,
} from '../models/PaginatedPipelineMapListList';
import {
    type PaginatedPlumeImageList,
    PaginatedPlumeImageListFromJSON,
    PaginatedPlumeImageListToJSON,
} from '../models/PaginatedPlumeImageList';
import {
    type PaginatedPlumeOulinesList,
    PaginatedPlumeOulinesListFromJSON,
    PaginatedPlumeOulinesListToJSON,
} from '../models/PaginatedPlumeOulinesList';
import {
    type PaginatedSiteMapListList,
    PaginatedSiteMapListListFromJSON,
    PaginatedSiteMapListListToJSON,
} from '../models/PaginatedSiteMapListList';
import {
    type PaginatedUnmatchedPlumeImageList,
    PaginatedUnmatchedPlumeImageListFromJSON,
    PaginatedUnmatchedPlumeImageListToJSON,
} from '../models/PaginatedUnmatchedPlumeImageList';
import {
    type PaginatedUnmatchedPlumeOutlineList,
    PaginatedUnmatchedPlumeOutlineListFromJSON,
    PaginatedUnmatchedPlumeOutlineListToJSON,
} from '../models/PaginatedUnmatchedPlumeOutlineList';
import {
    type PipelineMapList,
    PipelineMapListFromJSON,
    PipelineMapListToJSON,
} from '../models/PipelineMapList';
import {
    type PlumeImage,
    PlumeImageFromJSON,
    PlumeImageToJSON,
} from '../models/PlumeImage';
import {
    type PlumeOulines,
    PlumeOulinesFromJSON,
    PlumeOulinesToJSON,
} from '../models/PlumeOulines';
import {
    type SiteMapList,
    SiteMapListFromJSON,
    SiteMapListToJSON,
} from '../models/SiteMapList';
import {
    type UnmatchedPlumeImage,
    UnmatchedPlumeImageFromJSON,
    UnmatchedPlumeImageToJSON,
} from '../models/UnmatchedPlumeImage';
import {
    type UnmatchedPlumeOutline,
    UnmatchedPlumeOutlineFromJSON,
    UnmatchedPlumeOutlineToJSON,
} from '../models/UnmatchedPlumeOutline';

export interface MapAerialImagesListRequest {
    cursor?: string;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    site?: Array<string>;
    takenAtDataRangeAfter?: Date;
    takenAtDataRangeBefore?: Date;
    uniquePerSite?: boolean;
}

export interface MapAerialImagesRetrieveRequest {
    id: string;
}

export interface MapEmissionRecordsListRequest {
    assignedTo?: Array<number>;
    bridgerDetectionId?: string;
    bridgerEmissionLocationId?: string;
    bridgerEquipmentId?: string;
    bridgerEquipmentType?: string;
    bridgerLocation?: string;
    bridgerPersistence?: string;
    bridgerSiteName?: string;
    concentrationMax?: number | null;
    concentrationMin?: number | null;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    cursor?: string;
    dataPointCreatedAtAfter?: Date;
    dataPointCreatedAtBefore?: Date;
    dataSource?: Array<MapEmissionRecordsListDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    epaSepNotificationReason?: Array<MapEmissionRecordsListEpaSepNotificationReasonEnum>;
    eventStatus?: Array<MapEmissionRecordsListEventStatusEnum>;
    eventStatusWithParentStatus?: Array<MapEmissionRecordsListEventStatusWithParentStatusEnum>;
    eventUpdatedAtAfter?: Date;
    eventUpdatedAtBefore?: Date;
    excludeEventStatus?: Array<MapEmissionRecordsListExcludeEventStatusEnum>;
    ids?: Array<string>;
    isMainEvent?: boolean;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    plume?: boolean;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedEvent?: string;
    relatedSite?: string;
    relatedSiteName?: string;
    secondaryDataSource?: Array<string>;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface MapEmissionRecordsRetrieveRequest {
    id: string;
}

export interface MapEquipmentListRequest {
    cursor?: string;
    equipmentType?: Array<MapEquipmentListEquipmentTypeEnum>;
    locationPreset?: Array<number>;
    locationWithin?: string;
    nearEmission?: string;
    ordering?: string;
    site?: Array<string>;
}

export interface MapEquipmentRetrieveRequest {
    id: string;
}

export interface MapExtraDataSurveysListRequest {
    cursor?: string;
    dataType?: Array<MapExtraDataSurveysListDataTypeEnum>;
    endDatetimeAfter?: Date;
    endDatetimeBefore?: Date;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    startDatetimeAfter?: Date;
    startDatetimeBefore?: Date;
}

export interface MapExtraDataSurveysRetrieveRequest {
    id: string;
}

export interface MapPipelinesListRequest {
    cursor?: string;
    lengthMax?: number | null;
    lengthMin?: number | null;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    pipelineProduct?: Array<MapPipelinesListPipelineProductEnum>;
    pipelineType?: Array<MapPipelinesListPipelineTypeEnum>;
}

export interface MapPipelinesOverviewsRetrieveRequest {
    lengthMax?: number | null;
    lengthMin?: number | null;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    pipelineProduct?: Array<MapPipelinesOverviewsRetrievePipelineProductEnum>;
    pipelineType?: Array<MapPipelinesOverviewsRetrievePipelineTypeEnum>;
}

export interface MapPipelinesRetrieveRequest {
    id: string;
}

export interface MapPlumeImagesListRequest {
    cursor?: string;
    dataSource?: Array<MapPlumeImagesListDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    emission?: Array<string>;
    emissionCreatedAtAfter?: Date;
    emissionCreatedAtBefore?: Date;
    eventStatus?: Array<MapPlumeImagesListEventStatusEnum>;
    excludeEventStatus?: Array<MapPlumeImagesListExcludeEventStatusEnum>;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedSite?: string;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface MapPlumeImagesRetrieveRequest {
    id: string;
}

export interface MapPlumeOutlinesListRequest {
    cursor?: string;
    dataSource?: Array<MapPlumeOutlinesListDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    emission?: Array<string>;
    emissionCreatedAtAfter?: Date;
    emissionCreatedAtBefore?: Date;
    eventStatus?: Array<MapPlumeOutlinesListEventStatusEnum>;
    excludeEventStatus?: Array<MapPlumeOutlinesListExcludeEventStatusEnum>;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedSite?: string;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface MapPlumeOutlinesRetrieveRequest {
    id: string;
}

export interface MapPublicEmissionsListRequest {
    cursor?: string;
    dataSource?: Array<MapPublicEmissionsListDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    emission?: Array<string>;
    emissionCreatedAtAfter?: Date;
    emissionCreatedAtBefore?: Date;
    eventStatus?: Array<MapPublicEmissionsListEventStatusEnum>;
    excludeEventStatus?: Array<MapPublicEmissionsListExcludeEventStatusEnum>;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedSite?: string;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface MapPublicEmissionsRetrieveRequest {
    id: string;
}

export interface MapPublicPlumeImagesListRequest {
    cursor?: string;
    dataSource?: Array<MapPublicPlumeImagesListDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    emission?: Array<string>;
    emissionCreatedAtAfter?: Date;
    emissionCreatedAtBefore?: Date;
    eventStatus?: Array<MapPublicPlumeImagesListEventStatusEnum>;
    excludeEventStatus?: Array<MapPublicPlumeImagesListExcludeEventStatusEnum>;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedSite?: string;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface MapPublicPlumeImagesRetrieveRequest {
    id: string;
}

export interface MapPublicPlumeOutlinesListRequest {
    cursor?: string;
    dataSource?: Array<MapPublicPlumeOutlinesListDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    emission?: Array<string>;
    emissionCreatedAtAfter?: Date;
    emissionCreatedAtBefore?: Date;
    eventStatus?: Array<MapPublicPlumeOutlinesListEventStatusEnum>;
    excludeEventStatus?: Array<MapPublicPlumeOutlinesListExcludeEventStatusEnum>;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    provider?: Array<string>;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
    relatedSite?: string;
    site?: Array<string>;
    tentativeSite?: string;
}

export interface MapPublicPlumeOutlinesRetrieveRequest {
    id: string;
}

export interface MapSitesListRequest {
    cursor?: string;
    locationPreset?: Array<number>;
    locationWithin?: string;
    nearEmission?: string;
    ordering?: string;
}

export interface MapSitesOverviewsRetrieveRequest {
    boxSize?: number;
    locationPreset?: Array<number>;
    locationWithin?: string;
    nearEmission?: string;
    ordering?: string;
}

export interface MapSitesRetrieveRequest {
    id: string;
}

export interface MapUnmatchedDataPlumeOutlinesListRequest {
    bridgerDetectionId?: string;
    bridgerEmissionLocationId?: string;
    bridgerEquipmentId?: string;
    bridgerEquipmentType?: string;
    bridgerLocation?: string;
    bridgerPersistence?: string;
    bridgerSiteName?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    cursor?: string;
    decision?: Array<MapUnmatchedDataPlumeOutlinesListDecisionEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    ids?: Array<string>;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
}

export interface MapUnmatchedDataPlumeOutlinesRetrieveRequest {
    id: string;
}

export interface MapUnmatchedDataPlumesListRequest {
    cursor?: string;
    dataPoints?: Array<string>;
    dataSource?: Array<MapUnmatchedDataPlumesListDataSourceEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    ids?: Array<string>;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
}

export interface MapUnmatchedDataPlumesRetrieveRequest {
    id: string;
}

export interface MapUnmatchedDataPointsListRequest {
    bridgerDetectionId?: string;
    bridgerEmissionLocationId?: string;
    bridgerEquipmentId?: string;
    bridgerEquipmentType?: string;
    bridgerLocation?: string;
    bridgerPersistence?: string;
    bridgerSiteName?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    cursor?: string;
    decision?: Array<MapUnmatchedDataPointsListDecisionEnum>;
    detectedRateMax?: number | null;
    detectedRateMin?: number | null;
    detectionDateRangeAfter?: Date;
    detectionDateRangeBefore?: Date;
    ids?: Array<string>;
    locationPreset?: Array<number>;
    locationWithin?: string;
    ordering?: string;
    providerWithSource?: Array<AdminEmissionsRecordsStatsListProviderWithSourceParameterInner>;
}

export interface MapUnmatchedDataPointsRetrieveRequest {
    id: string;
}

/**
 * 
 */
export class MapApi extends runtime.BaseAPI {

    /**
     * Creates request options for mapAerialImagesList without sending the request
     */
    async mapAerialImagesListRequestOpts(requestParameters: MapAerialImagesListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['takenAtDataRangeAfter'] != null) {
            queryParameters['taken_at_data_range_after'] = (requestParameters['takenAtDataRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['takenAtDataRangeBefore'] != null) {
            queryParameters['taken_at_data_range_before'] = (requestParameters['takenAtDataRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['uniquePerSite'] != null) {
            queryParameters['unique_per_site'] = requestParameters['uniquePerSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/aerial-images/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve AerialImage information
     */
    async mapAerialImagesListRaw(requestParameters: MapAerialImagesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAerialImagesListList>> {
        const requestOptions = await this.mapAerialImagesListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAerialImagesListListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve AerialImage information
     */
    async mapAerialImagesList(requestParameters: MapAerialImagesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAerialImagesListList> {
        const response = await this.mapAerialImagesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapAerialImagesRetrieve without sending the request
     */
    async mapAerialImagesRetrieveRequestOpts(requestParameters: MapAerialImagesRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mapAerialImagesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/aerial-images/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve AerialImage information
     */
    async mapAerialImagesRetrieveRaw(requestParameters: MapAerialImagesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AerialImagesList>> {
        const requestOptions = await this.mapAerialImagesRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AerialImagesListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve AerialImage information
     */
    async mapAerialImagesRetrieve(requestParameters: MapAerialImagesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AerialImagesList> {
        const response = await this.mapAerialImagesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapEmissionRecordsList without sending the request
     */
    async mapEmissionRecordsListRequestOpts(requestParameters: MapEmissionRecordsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assigned_to'] = requestParameters['assignedTo'];
        }

        if (requestParameters['bridgerDetectionId'] != null) {
            queryParameters['bridger_detection_id'] = requestParameters['bridgerDetectionId'];
        }

        if (requestParameters['bridgerEmissionLocationId'] != null) {
            queryParameters['bridger_emission_location_id'] = requestParameters['bridgerEmissionLocationId'];
        }

        if (requestParameters['bridgerEquipmentId'] != null) {
            queryParameters['bridger_equipment_id'] = requestParameters['bridgerEquipmentId'];
        }

        if (requestParameters['bridgerEquipmentType'] != null) {
            queryParameters['bridger_equipment_type'] = requestParameters['bridgerEquipmentType'];
        }

        if (requestParameters['bridgerLocation'] != null) {
            queryParameters['bridger_location'] = requestParameters['bridgerLocation'];
        }

        if (requestParameters['bridgerPersistence'] != null) {
            queryParameters['bridger_persistence'] = requestParameters['bridgerPersistence'];
        }

        if (requestParameters['bridgerSiteName'] != null) {
            queryParameters['bridger_site_name'] = requestParameters['bridgerSiteName'];
        }

        if (requestParameters['concentrationMax'] != null) {
            queryParameters['concentration_max'] = requestParameters['concentrationMax'];
        }

        if (requestParameters['concentrationMin'] != null) {
            queryParameters['concentration_min'] = requestParameters['concentrationMin'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['dataPointCreatedAtAfter'] != null) {
            queryParameters['data_point_created_at_after'] = (requestParameters['dataPointCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataPointCreatedAtBefore'] != null) {
            queryParameters['data_point_created_at_before'] = (requestParameters['dataPointCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['epaSepNotificationReason'] != null) {
            queryParameters['epa_sep_notification_reason'] = requestParameters['epaSepNotificationReason'];
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['eventStatusWithParentStatus'] != null) {
            queryParameters['event_status_with_parent_status'] = requestParameters['eventStatusWithParentStatus'];
        }

        if (requestParameters['eventUpdatedAtAfter'] != null) {
            queryParameters['event_updated_at_after'] = (requestParameters['eventUpdatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventUpdatedAtBefore'] != null) {
            queryParameters['event_updated_at_before'] = (requestParameters['eventUpdatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['isMainEvent'] != null) {
            queryParameters['is_main_event'] = requestParameters['isMainEvent'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['plume'] != null) {
            queryParameters['plume'] = requestParameters['plume'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedEvent'] != null) {
            queryParameters['related_event'] = requestParameters['relatedEvent'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['relatedSiteName'] != null) {
            queryParameters['related_site_name'] = requestParameters['relatedSiteName'];
        }

        if (requestParameters['secondaryDataSource'] != null) {
            queryParameters['secondary_data_source'] = requestParameters['secondaryDataSource'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/emission-records/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve emissions information for the map
     */
    async mapEmissionRecordsListRaw(requestParameters: MapEmissionRecordsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedEmissionRecordMapList>> {
        const requestOptions = await this.mapEmissionRecordsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedEmissionRecordMapListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve emissions information for the map
     */
    async mapEmissionRecordsList(requestParameters: MapEmissionRecordsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedEmissionRecordMapList> {
        const response = await this.mapEmissionRecordsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapEmissionRecordsRetrieve without sending the request
     */
    async mapEmissionRecordsRetrieveRequestOpts(requestParameters: MapEmissionRecordsRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mapEmissionRecordsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/emission-records/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve emissions information for the map
     */
    async mapEmissionRecordsRetrieveRaw(requestParameters: MapEmissionRecordsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmissionRecordMap>> {
        const requestOptions = await this.mapEmissionRecordsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmissionRecordMapFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve emissions information for the map
     */
    async mapEmissionRecordsRetrieve(requestParameters: MapEmissionRecordsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmissionRecordMap> {
        const response = await this.mapEmissionRecordsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapEquipmentList without sending the request
     */
    async mapEquipmentListRequestOpts(requestParameters: MapEquipmentListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['equipmentType'] != null) {
            queryParameters['equipment_type'] = requestParameters['equipmentType'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['nearEmission'] != null) {
            queryParameters['near_emission'] = requestParameters['nearEmission'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/equipment/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve site map information
     */
    async mapEquipmentListRaw(requestParameters: MapEquipmentListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedEquipmentMapListList>> {
        const requestOptions = await this.mapEquipmentListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedEquipmentMapListListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve site map information
     */
    async mapEquipmentList(requestParameters: MapEquipmentListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedEquipmentMapListList> {
        const response = await this.mapEquipmentListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapEquipmentRetrieve without sending the request
     */
    async mapEquipmentRetrieveRequestOpts(requestParameters: MapEquipmentRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mapEquipmentRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/equipment/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve site map information
     */
    async mapEquipmentRetrieveRaw(requestParameters: MapEquipmentRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EquipmentMapList>> {
        const requestOptions = await this.mapEquipmentRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EquipmentMapListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve site map information
     */
    async mapEquipmentRetrieve(requestParameters: MapEquipmentRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EquipmentMapList> {
        const response = await this.mapEquipmentRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapExtraDataSurveysList without sending the request
     */
    async mapExtraDataSurveysListRequestOpts(requestParameters: MapExtraDataSurveysListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['dataType'] != null) {
            queryParameters['data_type'] = requestParameters['dataType'];
        }

        if (requestParameters['endDatetimeAfter'] != null) {
            queryParameters['end_datetime_after'] = (requestParameters['endDatetimeAfter'] as any).toISOString();
        }

        if (requestParameters['endDatetimeBefore'] != null) {
            queryParameters['end_datetime_before'] = (requestParameters['endDatetimeBefore'] as any).toISOString();
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['startDatetimeAfter'] != null) {
            queryParameters['start_datetime_after'] = (requestParameters['startDatetimeAfter'] as any).toISOString();
        }

        if (requestParameters['startDatetimeBefore'] != null) {
            queryParameters['start_datetime_before'] = (requestParameters['startDatetimeBefore'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/extra-data-surveys/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * API endpoint that allows data surveys to be viewed and managed.
     */
    async mapExtraDataSurveysListRaw(requestParameters: MapExtraDataSurveysListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDataSurveyList>> {
        const requestOptions = await this.mapExtraDataSurveysListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDataSurveyListFromJSON(jsonValue));
    }

    /**
     * API endpoint that allows data surveys to be viewed and managed.
     */
    async mapExtraDataSurveysList(requestParameters: MapExtraDataSurveysListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDataSurveyList> {
        const response = await this.mapExtraDataSurveysListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapExtraDataSurveysRetrieve without sending the request
     */
    async mapExtraDataSurveysRetrieveRequestOpts(requestParameters: MapExtraDataSurveysRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mapExtraDataSurveysRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/extra-data-surveys/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * API endpoint that allows data surveys to be viewed and managed.
     */
    async mapExtraDataSurveysRetrieveRaw(requestParameters: MapExtraDataSurveysRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataSurveyData>> {
        const requestOptions = await this.mapExtraDataSurveysRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DataSurveyDataFromJSON(jsonValue));
    }

    /**
     * API endpoint that allows data surveys to be viewed and managed.
     */
    async mapExtraDataSurveysRetrieve(requestParameters: MapExtraDataSurveysRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DataSurveyData> {
        const response = await this.mapExtraDataSurveysRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapPipelinesList without sending the request
     */
    async mapPipelinesListRequestOpts(requestParameters: MapPipelinesListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['lengthMax'] != null) {
            queryParameters['length_max'] = requestParameters['lengthMax'];
        }

        if (requestParameters['lengthMin'] != null) {
            queryParameters['length_min'] = requestParameters['lengthMin'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['pipelineProduct'] != null) {
            queryParameters['pipeline_product'] = requestParameters['pipelineProduct'];
        }

        if (requestParameters['pipelineType'] != null) {
            queryParameters['pipeline_type'] = requestParameters['pipelineType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/pipelines/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve pipeline information
     */
    async mapPipelinesListRaw(requestParameters: MapPipelinesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedPipelineMapListList>> {
        const requestOptions = await this.mapPipelinesListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPipelineMapListListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve pipeline information
     */
    async mapPipelinesList(requestParameters: MapPipelinesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedPipelineMapListList> {
        const response = await this.mapPipelinesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapPipelinesOverviewsRetrieve without sending the request
     */
    async mapPipelinesOverviewsRetrieveRequestOpts(requestParameters: MapPipelinesOverviewsRetrieveRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['lengthMax'] != null) {
            queryParameters['length_max'] = requestParameters['lengthMax'];
        }

        if (requestParameters['lengthMin'] != null) {
            queryParameters['length_min'] = requestParameters['lengthMin'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['pipelineProduct'] != null) {
            queryParameters['pipeline_product'] = requestParameters['pipelineProduct'];
        }

        if (requestParameters['pipelineType'] != null) {
            queryParameters['pipeline_type'] = requestParameters['pipelineType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/pipelines/overviews/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Computes clusters of pipelines to display in higher zoom levels.
     */
    async mapPipelinesOverviewsRetrieveRaw(requestParameters: MapPipelinesOverviewsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeoJSONFeatureCollection>> {
        const requestOptions = await this.mapPipelinesOverviewsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeoJSONFeatureCollectionFromJSON(jsonValue));
    }

    /**
     * Computes clusters of pipelines to display in higher zoom levels.
     */
    async mapPipelinesOverviewsRetrieve(requestParameters: MapPipelinesOverviewsRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeoJSONFeatureCollection> {
        const response = await this.mapPipelinesOverviewsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapPipelinesRetrieve without sending the request
     */
    async mapPipelinesRetrieveRequestOpts(requestParameters: MapPipelinesRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mapPipelinesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/pipelines/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve pipeline information
     */
    async mapPipelinesRetrieveRaw(requestParameters: MapPipelinesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PipelineMapList>> {
        const requestOptions = await this.mapPipelinesRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PipelineMapListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve pipeline information
     */
    async mapPipelinesRetrieve(requestParameters: MapPipelinesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PipelineMapList> {
        const response = await this.mapPipelinesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapPlumeImagesList without sending the request
     */
    async mapPlumeImagesListRequestOpts(requestParameters: MapPlumeImagesListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['emission'] != null) {
            queryParameters['emission'] = requestParameters['emission'];
        }

        if (requestParameters['emissionCreatedAtAfter'] != null) {
            queryParameters['emission_created_at_after'] = (requestParameters['emissionCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['emissionCreatedAtBefore'] != null) {
            queryParameters['emission_created_at_before'] = (requestParameters['emissionCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/plume-images/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve plume image information for the map.
     */
    async mapPlumeImagesListRaw(requestParameters: MapPlumeImagesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedPlumeImageList>> {
        const requestOptions = await this.mapPlumeImagesListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPlumeImageListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve plume image information for the map.
     */
    async mapPlumeImagesList(requestParameters: MapPlumeImagesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedPlumeImageList> {
        const response = await this.mapPlumeImagesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapPlumeImagesRetrieve without sending the request
     */
    async mapPlumeImagesRetrieveRequestOpts(requestParameters: MapPlumeImagesRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mapPlumeImagesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/plume-images/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve plume image information for the map.
     */
    async mapPlumeImagesRetrieveRaw(requestParameters: MapPlumeImagesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlumeImage>> {
        const requestOptions = await this.mapPlumeImagesRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlumeImageFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve plume image information for the map.
     */
    async mapPlumeImagesRetrieve(requestParameters: MapPlumeImagesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlumeImage> {
        const response = await this.mapPlumeImagesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapPlumeOutlinesList without sending the request
     */
    async mapPlumeOutlinesListRequestOpts(requestParameters: MapPlumeOutlinesListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['emission'] != null) {
            queryParameters['emission'] = requestParameters['emission'];
        }

        if (requestParameters['emissionCreatedAtAfter'] != null) {
            queryParameters['emission_created_at_after'] = (requestParameters['emissionCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['emissionCreatedAtBefore'] != null) {
            queryParameters['emission_created_at_before'] = (requestParameters['emissionCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/plume-outlines/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve plume outlines for the map.
     */
    async mapPlumeOutlinesListRaw(requestParameters: MapPlumeOutlinesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedPlumeOulinesList>> {
        const requestOptions = await this.mapPlumeOutlinesListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPlumeOulinesListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve plume outlines for the map.
     */
    async mapPlumeOutlinesList(requestParameters: MapPlumeOutlinesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedPlumeOulinesList> {
        const response = await this.mapPlumeOutlinesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapPlumeOutlinesRetrieve without sending the request
     */
    async mapPlumeOutlinesRetrieveRequestOpts(requestParameters: MapPlumeOutlinesRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mapPlumeOutlinesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/plume-outlines/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve plume outlines for the map.
     */
    async mapPlumeOutlinesRetrieveRaw(requestParameters: MapPlumeOutlinesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlumeOulines>> {
        const requestOptions = await this.mapPlumeOutlinesRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlumeOulinesFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve plume outlines for the map.
     */
    async mapPlumeOutlinesRetrieve(requestParameters: MapPlumeOutlinesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlumeOulines> {
        const response = await this.mapPlumeOutlinesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapPublicEmissionsList without sending the request
     */
    async mapPublicEmissionsListRequestOpts(requestParameters: MapPublicEmissionsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['emission'] != null) {
            queryParameters['emission'] = requestParameters['emission'];
        }

        if (requestParameters['emissionCreatedAtAfter'] != null) {
            queryParameters['emission_created_at_after'] = (requestParameters['emissionCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['emissionCreatedAtBefore'] != null) {
            queryParameters['emission_created_at_before'] = (requestParameters['emissionCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/public-emissions/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve public data point information for the map.
     */
    async mapPublicEmissionsListRaw(requestParameters: MapPublicEmissionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDataPointMapList>> {
        const requestOptions = await this.mapPublicEmissionsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDataPointMapListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve public data point information for the map.
     */
    async mapPublicEmissionsList(requestParameters: MapPublicEmissionsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDataPointMapList> {
        const response = await this.mapPublicEmissionsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapPublicEmissionsRetrieve without sending the request
     */
    async mapPublicEmissionsRetrieveRequestOpts(requestParameters: MapPublicEmissionsRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mapPublicEmissionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/public-emissions/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve public data point information for the map.
     */
    async mapPublicEmissionsRetrieveRaw(requestParameters: MapPublicEmissionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataPointMap>> {
        const requestOptions = await this.mapPublicEmissionsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DataPointMapFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve public data point information for the map.
     */
    async mapPublicEmissionsRetrieve(requestParameters: MapPublicEmissionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DataPointMap> {
        const response = await this.mapPublicEmissionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapPublicPlumeImagesList without sending the request
     */
    async mapPublicPlumeImagesListRequestOpts(requestParameters: MapPublicPlumeImagesListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['emission'] != null) {
            queryParameters['emission'] = requestParameters['emission'];
        }

        if (requestParameters['emissionCreatedAtAfter'] != null) {
            queryParameters['emission_created_at_after'] = (requestParameters['emissionCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['emissionCreatedAtBefore'] != null) {
            queryParameters['emission_created_at_before'] = (requestParameters['emissionCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/public-plume-images/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve public plume image information for the map.  FIXME: it feels like this one can be a simple filter.
     */
    async mapPublicPlumeImagesListRaw(requestParameters: MapPublicPlumeImagesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedPlumeImageList>> {
        const requestOptions = await this.mapPublicPlumeImagesListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPlumeImageListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve public plume image information for the map.  FIXME: it feels like this one can be a simple filter.
     */
    async mapPublicPlumeImagesList(requestParameters: MapPublicPlumeImagesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedPlumeImageList> {
        const response = await this.mapPublicPlumeImagesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapPublicPlumeImagesRetrieve without sending the request
     */
    async mapPublicPlumeImagesRetrieveRequestOpts(requestParameters: MapPublicPlumeImagesRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mapPublicPlumeImagesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/public-plume-images/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve public plume image information for the map.  FIXME: it feels like this one can be a simple filter.
     */
    async mapPublicPlumeImagesRetrieveRaw(requestParameters: MapPublicPlumeImagesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlumeImage>> {
        const requestOptions = await this.mapPublicPlumeImagesRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlumeImageFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve public plume image information for the map.  FIXME: it feels like this one can be a simple filter.
     */
    async mapPublicPlumeImagesRetrieve(requestParameters: MapPublicPlumeImagesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlumeImage> {
        const response = await this.mapPublicPlumeImagesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapPublicPlumeOutlinesList without sending the request
     */
    async mapPublicPlumeOutlinesListRequestOpts(requestParameters: MapPublicPlumeOutlinesListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['emission'] != null) {
            queryParameters['emission'] = requestParameters['emission'];
        }

        if (requestParameters['emissionCreatedAtAfter'] != null) {
            queryParameters['emission_created_at_after'] = (requestParameters['emissionCreatedAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['emissionCreatedAtBefore'] != null) {
            queryParameters['emission_created_at_before'] = (requestParameters['emissionCreatedAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['eventStatus'] != null) {
            queryParameters['event_status'] = requestParameters['eventStatus'];
        }

        if (requestParameters['excludeEventStatus'] != null) {
            queryParameters['exclude_event_status'] = requestParameters['excludeEventStatus'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['provider'] != null) {
            queryParameters['provider'] = requestParameters['provider'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        if (requestParameters['relatedSite'] != null) {
            queryParameters['related_site'] = requestParameters['relatedSite'];
        }

        if (requestParameters['site'] != null) {
            queryParameters['site'] = requestParameters['site'];
        }

        if (requestParameters['tentativeSite'] != null) {
            queryParameters['tentative_site'] = requestParameters['tentativeSite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/public-plume-outlines/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve public plume image information for the map.  FIXME: it feels like this one can be a simple filter.
     */
    async mapPublicPlumeOutlinesListRaw(requestParameters: MapPublicPlumeOutlinesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedPlumeOulinesList>> {
        const requestOptions = await this.mapPublicPlumeOutlinesListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedPlumeOulinesListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve public plume image information for the map.  FIXME: it feels like this one can be a simple filter.
     */
    async mapPublicPlumeOutlinesList(requestParameters: MapPublicPlumeOutlinesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedPlumeOulinesList> {
        const response = await this.mapPublicPlumeOutlinesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapPublicPlumeOutlinesRetrieve without sending the request
     */
    async mapPublicPlumeOutlinesRetrieveRequestOpts(requestParameters: MapPublicPlumeOutlinesRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mapPublicPlumeOutlinesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/public-plume-outlines/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve public plume image information for the map.  FIXME: it feels like this one can be a simple filter.
     */
    async mapPublicPlumeOutlinesRetrieveRaw(requestParameters: MapPublicPlumeOutlinesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlumeOulines>> {
        const requestOptions = await this.mapPublicPlumeOutlinesRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlumeOulinesFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve public plume image information for the map.  FIXME: it feels like this one can be a simple filter.
     */
    async mapPublicPlumeOutlinesRetrieve(requestParameters: MapPublicPlumeOutlinesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlumeOulines> {
        const response = await this.mapPublicPlumeOutlinesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapSitesList without sending the request
     */
    async mapSitesListRequestOpts(requestParameters: MapSitesListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['nearEmission'] != null) {
            queryParameters['near_emission'] = requestParameters['nearEmission'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/sites/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve site map information
     */
    async mapSitesListRaw(requestParameters: MapSitesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedSiteMapListList>> {
        const requestOptions = await this.mapSitesListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedSiteMapListListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve site map information
     */
    async mapSitesList(requestParameters: MapSitesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedSiteMapListList> {
        const response = await this.mapSitesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapSitesOverviewsRetrieve without sending the request
     */
    async mapSitesOverviewsRetrieveRequestOpts(requestParameters: MapSitesOverviewsRetrieveRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['boxSize'] != null) {
            queryParameters['box_size'] = requestParameters['boxSize'];
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['nearEmission'] != null) {
            queryParameters['near_emission'] = requestParameters['nearEmission'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/sites/overviews/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Computes overviews for infrastructure efficiently.
     */
    async mapSitesOverviewsRetrieveRaw(requestParameters: MapSitesOverviewsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GeoJSONFeatureCollection>> {
        const requestOptions = await this.mapSitesOverviewsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GeoJSONFeatureCollectionFromJSON(jsonValue));
    }

    /**
     * Computes overviews for infrastructure efficiently.
     */
    async mapSitesOverviewsRetrieve(requestParameters: MapSitesOverviewsRetrieveRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GeoJSONFeatureCollection> {
        const response = await this.mapSitesOverviewsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapSitesRetrieve without sending the request
     */
    async mapSitesRetrieveRequestOpts(requestParameters: MapSitesRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mapSitesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/sites/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve site map information
     */
    async mapSitesRetrieveRaw(requestParameters: MapSitesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SiteMapList>> {
        const requestOptions = await this.mapSitesRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SiteMapListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve site map information
     */
    async mapSitesRetrieve(requestParameters: MapSitesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SiteMapList> {
        const response = await this.mapSitesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapUnmatchedDataPlumeOutlinesList without sending the request
     */
    async mapUnmatchedDataPlumeOutlinesListRequestOpts(requestParameters: MapUnmatchedDataPlumeOutlinesListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['bridgerDetectionId'] != null) {
            queryParameters['bridger_detection_id'] = requestParameters['bridgerDetectionId'];
        }

        if (requestParameters['bridgerEmissionLocationId'] != null) {
            queryParameters['bridger_emission_location_id'] = requestParameters['bridgerEmissionLocationId'];
        }

        if (requestParameters['bridgerEquipmentId'] != null) {
            queryParameters['bridger_equipment_id'] = requestParameters['bridgerEquipmentId'];
        }

        if (requestParameters['bridgerEquipmentType'] != null) {
            queryParameters['bridger_equipment_type'] = requestParameters['bridgerEquipmentType'];
        }

        if (requestParameters['bridgerLocation'] != null) {
            queryParameters['bridger_location'] = requestParameters['bridgerLocation'];
        }

        if (requestParameters['bridgerPersistence'] != null) {
            queryParameters['bridger_persistence'] = requestParameters['bridgerPersistence'];
        }

        if (requestParameters['bridgerSiteName'] != null) {
            queryParameters['bridger_site_name'] = requestParameters['bridgerSiteName'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['decision'] != null) {
            queryParameters['decision'] = requestParameters['decision'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/unmatched-data/plume-outlines/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve plume outlines of unmatched data points for the map.
     */
    async mapUnmatchedDataPlumeOutlinesListRaw(requestParameters: MapUnmatchedDataPlumeOutlinesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedUnmatchedPlumeOutlineList>> {
        const requestOptions = await this.mapUnmatchedDataPlumeOutlinesListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedUnmatchedPlumeOutlineListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve plume outlines of unmatched data points for the map.
     */
    async mapUnmatchedDataPlumeOutlinesList(requestParameters: MapUnmatchedDataPlumeOutlinesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedUnmatchedPlumeOutlineList> {
        const response = await this.mapUnmatchedDataPlumeOutlinesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapUnmatchedDataPlumeOutlinesRetrieve without sending the request
     */
    async mapUnmatchedDataPlumeOutlinesRetrieveRequestOpts(requestParameters: MapUnmatchedDataPlumeOutlinesRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mapUnmatchedDataPlumeOutlinesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/unmatched-data/plume-outlines/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve plume outlines of unmatched data points for the map.
     */
    async mapUnmatchedDataPlumeOutlinesRetrieveRaw(requestParameters: MapUnmatchedDataPlumeOutlinesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnmatchedPlumeOutline>> {
        const requestOptions = await this.mapUnmatchedDataPlumeOutlinesRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnmatchedPlumeOutlineFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve plume outlines of unmatched data points for the map.
     */
    async mapUnmatchedDataPlumeOutlinesRetrieve(requestParameters: MapUnmatchedDataPlumeOutlinesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnmatchedPlumeOutline> {
        const response = await this.mapUnmatchedDataPlumeOutlinesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapUnmatchedDataPlumesList without sending the request
     */
    async mapUnmatchedDataPlumesListRequestOpts(requestParameters: MapUnmatchedDataPlumesListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['dataPoints'] != null) {
            queryParameters['data_points'] = requestParameters['dataPoints']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['dataSource'] != null) {
            queryParameters['data_source'] = requestParameters['dataSource'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/unmatched-data/plumes/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve unmatched plume images for the map.
     */
    async mapUnmatchedDataPlumesListRaw(requestParameters: MapUnmatchedDataPlumesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedUnmatchedPlumeImageList>> {
        const requestOptions = await this.mapUnmatchedDataPlumesListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedUnmatchedPlumeImageListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve unmatched plume images for the map.
     */
    async mapUnmatchedDataPlumesList(requestParameters: MapUnmatchedDataPlumesListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedUnmatchedPlumeImageList> {
        const response = await this.mapUnmatchedDataPlumesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapUnmatchedDataPlumesRetrieve without sending the request
     */
    async mapUnmatchedDataPlumesRetrieveRequestOpts(requestParameters: MapUnmatchedDataPlumesRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mapUnmatchedDataPlumesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/unmatched-data/plumes/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve unmatched plume images for the map.
     */
    async mapUnmatchedDataPlumesRetrieveRaw(requestParameters: MapUnmatchedDataPlumesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UnmatchedPlumeImage>> {
        const requestOptions = await this.mapUnmatchedDataPlumesRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UnmatchedPlumeImageFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve unmatched plume images for the map.
     */
    async mapUnmatchedDataPlumesRetrieve(requestParameters: MapUnmatchedDataPlumesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UnmatchedPlumeImage> {
        const response = await this.mapUnmatchedDataPlumesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapUnmatchedDataPointsList without sending the request
     */
    async mapUnmatchedDataPointsListRequestOpts(requestParameters: MapUnmatchedDataPointsListRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['bridgerDetectionId'] != null) {
            queryParameters['bridger_detection_id'] = requestParameters['bridgerDetectionId'];
        }

        if (requestParameters['bridgerEmissionLocationId'] != null) {
            queryParameters['bridger_emission_location_id'] = requestParameters['bridgerEmissionLocationId'];
        }

        if (requestParameters['bridgerEquipmentId'] != null) {
            queryParameters['bridger_equipment_id'] = requestParameters['bridgerEquipmentId'];
        }

        if (requestParameters['bridgerEquipmentType'] != null) {
            queryParameters['bridger_equipment_type'] = requestParameters['bridgerEquipmentType'];
        }

        if (requestParameters['bridgerLocation'] != null) {
            queryParameters['bridger_location'] = requestParameters['bridgerLocation'];
        }

        if (requestParameters['bridgerPersistence'] != null) {
            queryParameters['bridger_persistence'] = requestParameters['bridgerPersistence'];
        }

        if (requestParameters['bridgerSiteName'] != null) {
            queryParameters['bridger_site_name'] = requestParameters['bridgerSiteName'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['decision'] != null) {
            queryParameters['decision'] = requestParameters['decision'];
        }

        if (requestParameters['detectedRateMax'] != null) {
            queryParameters['detected_rate_max'] = requestParameters['detectedRateMax'];
        }

        if (requestParameters['detectedRateMin'] != null) {
            queryParameters['detected_rate_min'] = requestParameters['detectedRateMin'];
        }

        if (requestParameters['detectionDateRangeAfter'] != null) {
            queryParameters['detection_date_range_after'] = (requestParameters['detectionDateRangeAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['detectionDateRangeBefore'] != null) {
            queryParameters['detection_date_range_before'] = (requestParameters['detectionDateRangeBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['locationPreset'] != null) {
            queryParameters['location_preset'] = requestParameters['locationPreset'];
        }

        if (requestParameters['locationWithin'] != null) {
            queryParameters['location_within'] = requestParameters['locationWithin'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['providerWithSource'] != null) {
            queryParameters['provider_with_source'] = requestParameters['providerWithSource'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/unmatched-data/points/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve unmatched data point information for the map.
     */
    async mapUnmatchedDataPointsListRaw(requestParameters: MapUnmatchedDataPointsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedDataPointMapList>> {
        const requestOptions = await this.mapUnmatchedDataPointsListRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedDataPointMapListFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve unmatched data point information for the map.
     */
    async mapUnmatchedDataPointsList(requestParameters: MapUnmatchedDataPointsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedDataPointMapList> {
        const response = await this.mapUnmatchedDataPointsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for mapUnmatchedDataPointsRetrieve without sending the request
     */
    async mapUnmatchedDataPointsRetrieveRequestOpts(requestParameters: MapUnmatchedDataPointsRetrieveRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling mapUnmatchedDataPointsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // bearer_token authentication
        }

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }

        let urlPath = `/api/v1/map/unmatched-data/points/{id}/`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * A viewset to retrieve unmatched data point information for the map.
     */
    async mapUnmatchedDataPointsRetrieveRaw(requestParameters: MapUnmatchedDataPointsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DataPointMap>> {
        const requestOptions = await this.mapUnmatchedDataPointsRetrieveRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DataPointMapFromJSON(jsonValue));
    }

    /**
     * A viewset to retrieve unmatched data point information for the map.
     */
    async mapUnmatchedDataPointsRetrieve(requestParameters: MapUnmatchedDataPointsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DataPointMap> {
        const response = await this.mapUnmatchedDataPointsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const MapEmissionRecordsListDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type MapEmissionRecordsListDataSourceEnum = typeof MapEmissionRecordsListDataSourceEnum[keyof typeof MapEmissionRecordsListDataSourceEnum];
/**
 * @export
 */
export const MapEmissionRecordsListEpaSepNotificationReasonEnum = {
    EpaNotification: 'EPA_NOTIFICATION',
    MatchedInfrastructure: 'MATCHED_INFRASTRUCTURE',
    UserCreated: 'USER_CREATED'
} as const;
export type MapEmissionRecordsListEpaSepNotificationReasonEnum = typeof MapEmissionRecordsListEpaSepNotificationReasonEnum[keyof typeof MapEmissionRecordsListEpaSepNotificationReasonEnum];
/**
 * @export
 */
export const MapEmissionRecordsListEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type MapEmissionRecordsListEventStatusEnum = typeof MapEmissionRecordsListEventStatusEnum[keyof typeof MapEmissionRecordsListEventStatusEnum];
/**
 * @export
 */
export const MapEmissionRecordsListEventStatusWithParentStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type MapEmissionRecordsListEventStatusWithParentStatusEnum = typeof MapEmissionRecordsListEventStatusWithParentStatusEnum[keyof typeof MapEmissionRecordsListEventStatusWithParentStatusEnum];
/**
 * @export
 */
export const MapEmissionRecordsListExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type MapEmissionRecordsListExcludeEventStatusEnum = typeof MapEmissionRecordsListExcludeEventStatusEnum[keyof typeof MapEmissionRecordsListExcludeEventStatusEnum];
/**
 * @export
 */
export const MapEquipmentListEquipmentTypeEnum = {
    Equipment: 'EQUIPMENT',
    EquipmentComponent: 'EQUIPMENT_COMPONENT',
    EquipmentGroup: 'EQUIPMENT_GROUP',
    Site: 'SITE'
} as const;
export type MapEquipmentListEquipmentTypeEnum = typeof MapEquipmentListEquipmentTypeEnum[keyof typeof MapEquipmentListEquipmentTypeEnum];
/**
 * @export
 */
export const MapExtraDataSurveysListDataTypeEnum = {
    ChampionX: 'CHAMPION_X'
} as const;
export type MapExtraDataSurveysListDataTypeEnum = typeof MapExtraDataSurveysListDataTypeEnum[keyof typeof MapExtraDataSurveysListDataTypeEnum];
/**
 * @export
 */
export const MapPipelinesListPipelineProductEnum = {
    Condensate: 'CONDENSATE',
    NaturalGas: 'NATURAL_GAS',
    Ngl: 'NGL',
    Oil: 'OIL',
    Other: 'OTHER',
    Water: 'WATER'
} as const;
export type MapPipelinesListPipelineProductEnum = typeof MapPipelinesListPipelineProductEnum[keyof typeof MapPipelinesListPipelineProductEnum];
/**
 * @export
 */
export const MapPipelinesListPipelineTypeEnum = {
    Distribution: 'DISTRIBUTION',
    Gathering: 'GATHERING',
    Other: 'OTHER',
    Transmission: 'TRANSMISSION'
} as const;
export type MapPipelinesListPipelineTypeEnum = typeof MapPipelinesListPipelineTypeEnum[keyof typeof MapPipelinesListPipelineTypeEnum];
/**
 * @export
 */
export const MapPipelinesOverviewsRetrievePipelineProductEnum = {
    Condensate: 'CONDENSATE',
    NaturalGas: 'NATURAL_GAS',
    Ngl: 'NGL',
    Oil: 'OIL',
    Other: 'OTHER',
    Water: 'WATER'
} as const;
export type MapPipelinesOverviewsRetrievePipelineProductEnum = typeof MapPipelinesOverviewsRetrievePipelineProductEnum[keyof typeof MapPipelinesOverviewsRetrievePipelineProductEnum];
/**
 * @export
 */
export const MapPipelinesOverviewsRetrievePipelineTypeEnum = {
    Distribution: 'DISTRIBUTION',
    Gathering: 'GATHERING',
    Other: 'OTHER',
    Transmission: 'TRANSMISSION'
} as const;
export type MapPipelinesOverviewsRetrievePipelineTypeEnum = typeof MapPipelinesOverviewsRetrievePipelineTypeEnum[keyof typeof MapPipelinesOverviewsRetrievePipelineTypeEnum];
/**
 * @export
 */
export const MapPlumeImagesListDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type MapPlumeImagesListDataSourceEnum = typeof MapPlumeImagesListDataSourceEnum[keyof typeof MapPlumeImagesListDataSourceEnum];
/**
 * @export
 */
export const MapPlumeImagesListEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type MapPlumeImagesListEventStatusEnum = typeof MapPlumeImagesListEventStatusEnum[keyof typeof MapPlumeImagesListEventStatusEnum];
/**
 * @export
 */
export const MapPlumeImagesListExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type MapPlumeImagesListExcludeEventStatusEnum = typeof MapPlumeImagesListExcludeEventStatusEnum[keyof typeof MapPlumeImagesListExcludeEventStatusEnum];
/**
 * @export
 */
export const MapPlumeOutlinesListDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type MapPlumeOutlinesListDataSourceEnum = typeof MapPlumeOutlinesListDataSourceEnum[keyof typeof MapPlumeOutlinesListDataSourceEnum];
/**
 * @export
 */
export const MapPlumeOutlinesListEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type MapPlumeOutlinesListEventStatusEnum = typeof MapPlumeOutlinesListEventStatusEnum[keyof typeof MapPlumeOutlinesListEventStatusEnum];
/**
 * @export
 */
export const MapPlumeOutlinesListExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type MapPlumeOutlinesListExcludeEventStatusEnum = typeof MapPlumeOutlinesListExcludeEventStatusEnum[keyof typeof MapPlumeOutlinesListExcludeEventStatusEnum];
/**
 * @export
 */
export const MapPublicEmissionsListDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type MapPublicEmissionsListDataSourceEnum = typeof MapPublicEmissionsListDataSourceEnum[keyof typeof MapPublicEmissionsListDataSourceEnum];
/**
 * @export
 */
export const MapPublicEmissionsListEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type MapPublicEmissionsListEventStatusEnum = typeof MapPublicEmissionsListEventStatusEnum[keyof typeof MapPublicEmissionsListEventStatusEnum];
/**
 * @export
 */
export const MapPublicEmissionsListExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type MapPublicEmissionsListExcludeEventStatusEnum = typeof MapPublicEmissionsListExcludeEventStatusEnum[keyof typeof MapPublicEmissionsListExcludeEventStatusEnum];
/**
 * @export
 */
export const MapPublicPlumeImagesListDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type MapPublicPlumeImagesListDataSourceEnum = typeof MapPublicPlumeImagesListDataSourceEnum[keyof typeof MapPublicPlumeImagesListDataSourceEnum];
/**
 * @export
 */
export const MapPublicPlumeImagesListEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type MapPublicPlumeImagesListEventStatusEnum = typeof MapPublicPlumeImagesListEventStatusEnum[keyof typeof MapPublicPlumeImagesListEventStatusEnum];
/**
 * @export
 */
export const MapPublicPlumeImagesListExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type MapPublicPlumeImagesListExcludeEventStatusEnum = typeof MapPublicPlumeImagesListExcludeEventStatusEnum[keyof typeof MapPublicPlumeImagesListExcludeEventStatusEnum];
/**
 * @export
 */
export const MapPublicPlumeOutlinesListDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type MapPublicPlumeOutlinesListDataSourceEnum = typeof MapPublicPlumeOutlinesListDataSourceEnum[keyof typeof MapPublicPlumeOutlinesListDataSourceEnum];
/**
 * @export
 */
export const MapPublicPlumeOutlinesListEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type MapPublicPlumeOutlinesListEventStatusEnum = typeof MapPublicPlumeOutlinesListEventStatusEnum[keyof typeof MapPublicPlumeOutlinesListEventStatusEnum];
/**
 * @export
 */
export const MapPublicPlumeOutlinesListExcludeEventStatusEnum = {
    Archived: 'ARCHIVED',
    Completed: 'COMPLETED',
    Created: 'CREATED',
    Linked: 'LINKED',
    New: 'NEW',
    Rejected: 'REJECTED',
    WaitingApproval: 'WAITING_APPROVAL',
    WorkInProgress: 'WORK_IN_PROGRESS'
} as const;
export type MapPublicPlumeOutlinesListExcludeEventStatusEnum = typeof MapPublicPlumeOutlinesListExcludeEventStatusEnum[keyof typeof MapPublicPlumeOutlinesListExcludeEventStatusEnum];
/**
 * @export
 */
export const MapUnmatchedDataPlumeOutlinesListDecisionEnum = {
    NotOwnedByCompany: 'NOT_OWNED_BY_COMPANY',
    OwnedAndLinkToSite: 'OWNED_AND_LINK_TO_SITE',
    OwnedButNoSite: 'OWNED_BUT_NO_SITE',
    Pending: 'PENDING'
} as const;
export type MapUnmatchedDataPlumeOutlinesListDecisionEnum = typeof MapUnmatchedDataPlumeOutlinesListDecisionEnum[keyof typeof MapUnmatchedDataPlumeOutlinesListDecisionEnum];
/**
 * @export
 */
export const MapUnmatchedDataPlumesListDataSourceEnum = {
    Epa: 'EPA',
    SelfReported: 'SELF_REPORTED',
    ThirdParty: 'THIRD_PARTY'
} as const;
export type MapUnmatchedDataPlumesListDataSourceEnum = typeof MapUnmatchedDataPlumesListDataSourceEnum[keyof typeof MapUnmatchedDataPlumesListDataSourceEnum];
/**
 * @export
 */
export const MapUnmatchedDataPointsListDecisionEnum = {
    NotOwnedByCompany: 'NOT_OWNED_BY_COMPANY',
    OwnedAndLinkToSite: 'OWNED_AND_LINK_TO_SITE',
    OwnedButNoSite: 'OWNED_BUT_NO_SITE',
    Pending: 'PENDING'
} as const;
export type MapUnmatchedDataPointsListDecisionEnum = typeof MapUnmatchedDataPointsListDecisionEnum[keyof typeof MapUnmatchedDataPointsListDecisionEnum];
